import CommentsContent from './CommentsContent';

export default CommentsContent;
